export const executeCallbackFunction = async (callbackFunction) => {
    if (callbackFunction.constructor.name === 'AsyncFunction') {
        await callbackFunction();
    }
    else {
        callbackFunction();
    }
};
//# sourceMappingURL=callback.js.map